<script setup>
import { ref } from 'vue'
import NavRailItem from '../components/NavRailItem.vue'
import DonationButton from '../components/DonationButton.vue'

const dialog = ref(false)
const costs = [
  { icon: 'mdi-server', label: 'Server', amount: '€50' },
  { icon: 'mdi-email', label: 'Emails', amount: '€16' },
  { icon: 'mdi-test-tube', label: 'Test server', amount: '€15' },
  { icon: 'mdi-cloud', label: 'CDN', amount: '€1' },
]
</script>

<template><NavRailItem icon="heart" label="Donate" variant="donation" @click="dialog = true" />
  <v-dialog v-model="dialog" width="520" scrollable transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar color="primary">
        <v-icon class="mr-2">mdi-heart</v-icon>
        <v-toolbar-title class="donate-toolbar-title">Support NightRiderz</v-toolbar-title>
        <v-spacer />
        <v-btn icon variant="text" @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <div class="settings-tab-page">
          <div class="settings-tab-header">
            <div class="header-icon danger"><v-icon>mdi-heart</v-icon></div>
            <div class="header-content"><h3 class="page-title">Keep the servers online</h3><p class="page-subtitle">100% goes to infrastructure — no perks, no rewards.</p></div>
          </div>
          <div class="section-list">
            <div v-for="cost in costs" :key="cost.label" class="section-row"><div class="section-body cost-row"><div class="cost-left"><v-icon size="18">{{ cost.icon }}</v-icon><span>{{ cost.label }}</span></div><strong>{{ cost.amount }}/mo</strong></div></div>
            <div class="section-row total-row"><div class="section-body cost-row"><span>Monthly total</span><strong>€82 / month</strong></div></div>
          </div>
          <p class="dialog-lead donate-note">Your support keeps NightRiderz running for everyone.</p>
          <DonationButton />
        </div>
      </v-card-text>
    </v-card>
  </v-dialog></template>

<style scoped>
.donate-toolbar-title {
  flex:0 1 auto!important;
  width:auto!important;
  max-width:none!important;
  overflow:visible!important;
  text-overflow:clip!important;
  white-space:nowrap!important}
.cost-row {
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
  color:var(--ink-soft);
  font-size:.88rem}
.cost-left {
  display:flex;
  align-items:center;
  gap:10px}
.cost-row strong {
  color:var(--ink);
  font-weight:700}
.total-row {
  border-color:#f4433647!important;
  background:#f4433614!important}
.total-row .cost-row {
  color:var(--status-danger)}
.donate-note {
  margin:16px 0 14px;
  text-align:center}
</style>
